import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function Customization() {
    return (
        <section className="space-y-10">

            {/* HERO */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-3">
                    Customization
                </h1>
                <p className="text-md text-slate-600 max-w-4xl">
                    EventFlow is built to adapt to your banquet’s workflow, policies,
                    pricing structure, and operational style — not the other way around.
                </p>

                <section className="bg-white border-l-4 border-[#C9A24E] p-4 mt-6">
                    <h2 className="text-lg font-semibold mb-2">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        Every banquet operates differently. EventFlow allows deep
                        customization so the system feels native to your business.
                    </p>
                </section>
            </section>

            {/* WHY CUSTOMIZATION */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Why Customization Is Important
                </h2>

                <p className="text-slate-600 max-w-4xl mb-4">
                    Generic software forces businesses to change their workflows.
                    EventFlow does the opposite — it molds itself around your operations.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Every banquet has unique pricing logic</li>
                    <li>Operational rules vary by management</li>
                    <li>Approval flows differ between organizations</li>
                    <li>Local tax rules and policies must be respected</li>
                </ul>
            </section>

            {/* WHAT CAN BE CUSTOMIZED */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-6">
                    What Can Be Customized in EventFlow
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-slate-600">
                    <ul className="list-disc pl-5 space-y-2">
                        <li>Booking forms & required fields</li>
                        <li>Service cards & pricing models</li>
                        <li>Tax rules & calculation logic</li>
                        <li>Invoice & receipt formats</li>
                    </ul>

                    <ul className="list-disc pl-5 space-y-2">
                        <li>Approval workflows</li>
                        <li>User roles & permissions</li>
                        <li>Reports & summaries</li>
                        <li>Dashboard metrics</li>
                    </ul>
                </div>
            </section>

            {/* REAL SCENARIO */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Real-world Customization Example
                </h2>

                <p className="text-slate-600 max-w-4xl">
                    A banquet may require:
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2 mt-4">
                    <li>Different rent for morning vs evening slots</li>
                    <li>Optional services shown only for specific occasions</li>
                    <li>Manual approval for high-value discounts</li>
                    <li>Custom invoice notes & terms</li>
                </ul>

                <p className="text-slate-600 mt-4">
                    EventFlow supports all of these without disrupting core stability.
                </p>
            </section>

            {/* BUSINESS IMPACT */}
            <section className="bg-white border border-slate-200 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    Business Impact
                </h2>

                <p className="text-slate-600 max-w-4xl">
                    Customization improves staff adoption, reduces errors, and ensures
                    the system feels like an internal tool rather than third-party software.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/integration" className="font-medium text-[#C9A24E]">
                        Integration
                    </Link>.
                </p>
            </section> */}
    <DocNavigation
                previous={{
                    title: "Staff Efficiency",
                    link: "/docs/staff-efficiency"
                }}
                next={{
                    title: "Integration",
                    link: "/docs/integration"
                }}
            />
        </section>
    );
}
